/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AppointmentExchangeResponse } from './AppointmentExchangeResponse';
import {
    AppointmentExchangeResponseFromJSON,
    AppointmentExchangeResponseFromJSONTyped,
    AppointmentExchangeResponseToJSON,
    AppointmentExchangeResponseToJSONTyped,
} from './AppointmentExchangeResponse';
import type { AppointmentExchangeOfferResponse } from './AppointmentExchangeOfferResponse';
import {
    AppointmentExchangeOfferResponseFromJSON,
    AppointmentExchangeOfferResponseFromJSONTyped,
    AppointmentExchangeOfferResponseToJSON,
    AppointmentExchangeOfferResponseToJSONTyped,
} from './AppointmentExchangeOfferResponse';

/**
 * 
 * @export
 * @interface AppointmentExchangeDetailResponse
 */
export interface AppointmentExchangeDetailResponse {
    /**
     * 
     * @type {AppointmentExchangeResponse}
     * @memberof AppointmentExchangeDetailResponse
     */
    request: AppointmentExchangeResponse;
    /**
     * 
     * @type {Array<AppointmentExchangeOfferResponse>}
     * @memberof AppointmentExchangeDetailResponse
     */
    offers: Array<AppointmentExchangeOfferResponse>;
}

/**
 * Check if a given object implements the AppointmentExchangeDetailResponse interface.
 */
export function instanceOfAppointmentExchangeDetailResponse(value: object): value is AppointmentExchangeDetailResponse {
    if (!('request' in value) || value['request'] === undefined) return false;
    if (!('offers' in value) || value['offers'] === undefined) return false;
    return true;
}

export function AppointmentExchangeDetailResponseFromJSON(json: any): AppointmentExchangeDetailResponse {
    return AppointmentExchangeDetailResponseFromJSONTyped(json, false);
}

export function AppointmentExchangeDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentExchangeDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'request': AppointmentExchangeResponseFromJSON(json['request']),
        'offers': ((json['offers'] as Array<any>).map(AppointmentExchangeOfferResponseFromJSON)),
    };
}

export function AppointmentExchangeDetailResponseToJSON(json: any): AppointmentExchangeDetailResponse {
    return AppointmentExchangeDetailResponseToJSONTyped(json, false);
}

export function AppointmentExchangeDetailResponseToJSONTyped(value?: AppointmentExchangeDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'request': AppointmentExchangeResponseToJSON(value['request']),
        'offers': ((value['offers'] as Array<any>).map(AppointmentExchangeOfferResponseToJSON)),
    };
}

